<script>
  // external libraries
  import { Label, Input, Collapse } from "sveltestrap";
  import {
    clearCacheAll,
    systemLog,
    defaultArtboardSets,
    updatePreference,
    showRuler,
    unlockNew,
    nRecommendations,
    nMoreLikeThis,
    responsiveDir,
    pDrastic,
    lossWeight,
    updateLossWeight,
    menuConfig,
  } from "../../editor/storage.js";
  import {
    updateDefaultArtboards,
    ResponsiveDirections,
    PrefKeys,
  } from "../../editor/component/preference.js";
  import { deviceTypes } from "../../editor/component/artboard.js";
  import ItemResponse from "../component/ItemResponse.svelte";
  import { firstLevelMenus } from "../../editor/menuSchema.js";
  import { cost_description } from "../../recommender/loss/evaluate.js";

  // event functions
  export let inputFocusAction;
  export let inputBlurAction;
  // clear cache
  const clearCacheConfirmString = "Clear Cache";
  let clearCacheConfirm = false;
  function checkClearCacheValue(event) {
    if (event.target.value === clearCacheConfirmString)
      clearCacheConfirm = true;
  }
  // default artboards
  let screen_type_options = Object.keys(deviceTypes);
  function updateArtbaord(action, role, i, event, artboard) {
    let previous_screen_type = action === "add" ? "new" : artboard.name;
    if (role === "screen_type") {
      artboard["name"] = event.target.value;
      artboard["type"] = artboard["name"].toLowerCase().split("-")[0];
      artboard["orient"] = artboard["name"].toLowerCase().split("-")[1];
    } else if (role === "width") {
      artboard["artboard_width"] = parseFloat(event.target.value);
    } else if (role === "height") {
      artboard["artboard_height"] = parseFloat(event.target.value);
    }
    updateDefaultArtboards(action, i, artboard);
    if (action === "remove") {
      $systemLog.log({
        message: `Remove artboard preset`,
        previous_screen_type,
      });
    } else {
      $systemLog.log({
        message: `Update artboard preset (${role || "-"})`,
        previous_screen_type,
      });
    }
  }
  let editArtboardMode = undefined;
  let defaultArtboardDesign;
  let currArtboardPresetIndex;
  function editArtboardPreset(mode, i, design) {
    editArtboardMode = mode;
    defaultArtboardDesign = design;
    currArtboardPresetIndex = i;
    if (editArtboardMode === "new") {
      updateArtbaord("add", null, null, null, {});
      currArtboardPresetIndex = $defaultArtboardSets.length - 1;
      defaultArtboardDesign =
        $defaultArtboardSets[currArtboardPresetIndex] || {};
    }
  }

  let showWeight = {
    identification: false,
    comparison: false,
    trend: false,
    text: false,
    density: false,
  };

  function updateLossCost(key, event) {
    let val = parseFloat(event.target.value);
    if (!isNaN(val)) {
      updateLossWeight(key, val);
    }
  }

  let subMenu;
  function setSubMenu(s) {
    subMenu = s;
  }
  function cancelSubMenu() {
    subMenu = undefined;
    editArtboardMode = undefined;
  }

  menuConfig.subscribe((config) => {
    if (config?.subMenu === "recommender_paramenters") {
      setSubMenu("recommender_paramenters");
    }
  });
</script>

{#if !subMenu}
  <h2>
    {firstLevelMenus["preference"]?.title || "Preferences"}
  </h2>
  <div class="dupo-menu-pane mb-2">
    <div class="dupo-menu-pane-form-row">
      <button
        type="button"
        class="menu-second-level"
        on:click={() => {
          updatePreference(PrefKeys.showRuler, !$showRuler);
          $systemLog.log({
            message: "Toggled showRuler (" + $showRuler + ")",
            option: $showRuler,
          });
        }}
      >
        <i
          class={`bi bi-${$showRuler ? "check-square-fill" : "square"} me-1 ${
            $showRuler ? "checked" : "unchecked"
          }`}
        /> Show device dimensions
      </button>
    </div>
    <div class="dupo-menu-pane-form-row">
      <button
        type="button"
        class="menu-second-level"
        on:click={() => {
          updatePreference(PrefKeys.unlockNew, !$unlockNew);
          $systemLog.log({
            message: "Toggled unlockNew (" + $unlockNew + ")",
            option: $unlockNew,
          });
        }}
      >
        <i
          class={`bi bi-${$unlockNew ? "check-square-fill" : "square"} me-1 ${
            $unlockNew ? "checked" : "unchecked"
          }`}
        /> Unlock new artboards
      </button>
    </div>
    <div class="dupo-menu-pane-row">
      <p class="text-sm mb-2">
        If checked, a new artboard (created or duplicated) is unlcoked by
        default.
      </p>
    </div>
    <div class="dupo-menu-pane-form-row">
      <button
        class="menu-second-level"
        type="button"
        on:click={() => {
          setSubMenu("default_artboards");
          $systemLog.log({ message: "Open editing default artboards" });
        }}
      >
        <i class="bi bi-layout-wtf me-1" />Default artboards</button
      >
    </div>
    <!-- experimenting feature -->
    <!-- <div class="dupo-menu-pane-form-row">
      <button
        class="menu-second-level"
        type="button"
        on:click={() => {
          setSubMenu("design_direction");
          $systemLog.log({ message: "Open editing design directions" });
        }}
      >
        <i class="bi bi-signpost me-1" />Design direction</button
      >
    </div> -->
    <div class="dupo-menu-pane-form-row">
      <button
        class="menu-second-level"
        type="button"
        on:click={() => {
          setSubMenu("recommender_paramenters");
          $systemLog.log({ message: "Open editing exploration parameters" });
        }}
      >
        <i class="bi bi-sliders me-1" />Exploration parameters</button
      >
    </div>
    <div class="dupo-menu-pane-form-row">
      <button
        class="menu-second-level"
        type="button"
        on:click={() => {
          setSubMenu("clear_cache");
          $systemLog.log({ message: "Open editing cache clearance" });
        }}
      >
        <i class="bi bi-eraser-fill me-1" />Clear Cache</button
      >
    </div>
  </div>
{:else if subMenu === "clear_cache"}
  <!-- clear cache -->
  <div class="dupo-menu-pane mb-2 pt-3">
    <div class="dupo-menu-pane-row mb-2">
      <Label for="clear_cache">Clear All Cache</Label>
      <p class="text-sm">
        Warning: If you clear all cache, all the removed data cannot be
        restored. To clear cache, type "Clear Cache" below (case-sensitive).
      </p>
    </div>
    <div class="dupo-menu-pane-form-row mb-2">
      <Input
        type="text"
        id="clear_cache"
        name="clear_cache"
        class="custom-form-select"
        autocomplete="off"
        on:focus={inputFocusAction}
        on:blur={inputBlurAction}
        on:keyup={(event) => checkClearCacheValue(event)}
      />
    </div>
    <div class="dupo-menu-pane-button-row mb-2">
      {#if clearCacheConfirm}
        <button
          type="button"
          class="danger"
          on:click={() => {
            clearCacheAll();
            cancelSubMenu();
            $systemLog.log({ message: "Clear all cache" });
            $systemLog.log({
              message: `Close cache clearance`,
            });
          }}
        >
          I understood, clear cache.
        </button>
      {:else}
        <button type="button" disabled>I understood, clear cache.</button>
      {/if}
    </div>
    <div class="dupo-menu-pane-button-row">
      <button
        type="button"
        on:click={() => {
          cancelSubMenu();
          $systemLog.log({
            message: `Close cache clearance`,
          });
        }}><i class="bi bi-arrow-left me-1" />Go back</button
      >
    </div>
  </div>
{:else if subMenu === "default_artboards"}
  <div class="dupo-menu-pane mb-2 pt-3">
    <div class="dupo-menu-pane-row">
      <Label>Default artboards</Label>
      <p class="text-sm">
        The following set of artboards is automatically generated when you
        initiate the system unless already created.
      </p>
    </div>
  </div>
  {#if editArtboardMode}
    <div class="dupo-menu-pane mb-2">
      <div class="dupo-menu-pane-row">
        <h3 class="h-sub">
          {editArtboardMode === "new"
            ? "New default artboard"
            : "Default artboard for " + defaultArtboardDesign?.name}
        </h3>
      </div>
    </div>
    <div class="dupo-menu-pane mb-2">
      <ItemResponse
        token={`type-${currArtboardPresetIndex}`}
        title="Screen type"
        type="select"
        options={screen_type_options}
        value={defaultArtboardDesign?.name}
        {inputFocusAction}
        {inputBlurAction}
        changeAction={(event) => {
          updateArtbaord(
            "modify",
            "screen_type",
            currArtboardPresetIndex,
            event,
            defaultArtboardDesign
          );
        }}
      />
    </div>
    <div class="dupo-menu-pane mb-2">
      <ItemResponse
        token={`width-${currArtboardPresetIndex}`}
        title="Artboard width"
        type="size"
        value={defaultArtboardDesign?.artboard_width}
        {inputFocusAction}
        {inputBlurAction}
        changeAction={(event) => {
          updateArtbaord(
            "modify",
            "width",
            currArtboardPresetIndex,
            event,
            defaultArtboardDesign
          );
        }}
      />
    </div>
    <div class="dupo-menu-pane mb-2">
      <ItemResponse
        token={`height-${currArtboardPresetIndex}`}
        title="Artboard height"
        type="size"
        value={defaultArtboardDesign?.artboard_height}
        {inputFocusAction}
        {inputBlurAction}
        changeAction={(event) => {
          updateArtbaord(
            "modify",
            "height",
            currArtboardPresetIndex,
            event,
            defaultArtboardDesign
          );
        }}
      />
    </div>
    <div class="dupo-menu-pane mb-2">
      <div class="dupo-menu-pane-button-row">
        <button
          type="button"
          on:click={() => {
            updateArtbaord(
              "remove",
              null,
              currArtboardPresetIndex,
              null,
              defaultArtboardDesign
            );
            editArtboardMode = undefined;
          }}><i class="bi bi-eraser me-1" />Delete this artboard preset</button
        >
      </div>
    </div>
    <div class="pane-divider" />
    <div class="dupo-menu-pane mb-2">
      <div class="dupo-menu-pane-button-row">
        <button
          type="button"
          on:click={() => {
            editArtboardMode = undefined;
          }}><i class="bi bi-arrow-left me-1" />Go back</button
        >
      </div>
    </div>
  {:else}
    <div class="dupo-menu-pane mb-2">
      {#each $defaultArtboardSets as preset, i}
        <div class="dupo-menu-pane-form-row">
          <button
            class="menu-second-level"
            type="button"
            on:click={() => editArtboardPreset("edit", i, preset)}
          >
            <i class="bi bi-pencil me-1" />Edit {preset.name}</button
          >
        </div>
      {/each}
    </div>
    <div class="pane-divider" />
    <div class="dupo-menu-pane mb-2">
      <div class="dupo-menu-pane-button-row">
        <button
          type="button"
          on:click={() => {
            editArtboardPreset("new", undefined, undefined);
          }}
          ><i class="bi bi-plus-circle me-1" />Add a new default artboard</button
        >
      </div>
    </div>
    <div class="pane-divider" />
    <div class="dupo-menu-pane mb-2">
      <div class="dupo-menu-pane-button-row">
        <button
          type="button"
          on:click={() => {
            cancelSubMenu();
            $systemLog.log({
              message: `Close editing default artboards`,
            });
          }}><i class="bi bi-arrow-left me-1" />Go back</button
        >
      </div>
    </div>
  {/if}
{:else if subMenu === "recommender_paramenters"}
  <div class="dupo-menu-pane mb-2 pt-3">
    <div class="dupo-menu-pane-row">
      <Label>Recommender parameters</Label>
      <p class="text-sm">Adjust recommender parameters.</p>
    </div>
  </div>
  <!-- n recs -->
  <div class="dupo-menu-pane mb-2">
    <div class="dupo-menu-pane-form-row">
      <ItemResponse
        type="number"
        token={PrefKeys.nRecommendations}
        title="The number of views per recommendation"
        value={$nRecommendations}
        min={0}
        {inputFocusAction}
        {inputBlurAction}
        changeAction={(event) => {
          updatePreference(
            PrefKeys.nRecommendations,
            parseInt(event.target.value)
          );
          $systemLog.log({
            message: "Update the number of recommendations",
            option: $nRecommendations,
          });
        }}
      />
    </div>
    <div class="dupo-menu-pane-row mt-1">
      <p class="text-sm">
        For unlimited recommendations, provide 0. A bigger number of
        recommendations may increase the system latency.
      </p>
    </div>
  </div>
  <!-- n more-like-this -->
  <div class="dupo-menu-pane mb-2">
    <div class="dupo-menu-pane-form-row">
      <ItemResponse
        type="number"
        token={PrefKeys.nMoreLikeThis}
        title="The number of views for Similar Designs"
        value={$nMoreLikeThis}
        min={0}
        {inputFocusAction}
        {inputBlurAction}
        changeAction={(event) => {
          updatePreference(
            PrefKeys.nMoreLikeThis,
            parseInt(event.target.value)
          );
          $systemLog.log({
            message: "Update the number of more-like-this-s",
            option: $nMoreLikeThis,
          });
        }}
      />
    </div>
    <div class="dupo-menu-pane-row mt-1">
      <p class="text-sm">
        For unlimited simialr designs. A bigger number of recommendations
        may increase the system latency.
      </p>
    </div>
  </div>
  <!-- p drastic -->
  <div class="dupo-menu-pane mb-2">
    <div class="dupo-menu-pane-form-row">
      <ItemResponse
        type="opacity"
        token={PrefKeys.pDrastic}
        title="The ratio of alternatives with drastic changes"
        value={$pDrastic}
        min={0.0001}
        max={0.9999}
        {inputFocusAction}
        {inputBlurAction}
        changeAction={(event) => {
          updatePreference(PrefKeys.pDrastic, parseFloat(event.target.value));
          $systemLog.log({
            message: "Update the ratio of drastic designs",
            option: $pDrastic,
          });
        }}
      />
    </div>
    <div class="dupo-menu-pane-row mt-1">
      <p class="text-sm">
        The ratio of design alternatives with relatively drastic changes among
        recommendations. If there are fewer recommendations than the number of
        recommendations, then the entire recommendations will be shown (i.e.,
        not effective).
      </p>
    </div>
  </div>
  <div class="pane-divider" />
  <!-- loss weights -->
  <div class="dupo-menu-pane mb-2">
    <div class="dupo-menu-pane-row">
      <Label>Weights for message and density loss</Label>
    </div>
    <div class="dupo-menu-pane-row mt-1">
      <p class="text-sm">
        Weights (or emphases) on the message and density loss measures for
        recommendations. The higher the weight, the more important each
        criterion is. By expanding a criterion, you can adjust weights for the
        criterion and its sub-criteria.
      </p>
    </div>
  </div>
  {#each Object.keys($lossWeight) as cat}
    <div class="dupo-menu-pane mb-2">
      <div class="dupo-menu-pane-form-row">
        <button
          class="menu-second-level"
          on:click={() => {
            showWeight[cat] = !showWeight[cat];
          }}
          ><i
            class={"bi bi-" +
              (showWeight[cat] ? "caret-down-fill" : "caret-right") +
              " me-1"}
          />{cost_description[cat]?.weight?.name}
          <span class="value-preview">{$lossWeight[cat].weight}</span></button
        >
      </div>
    </div>
    <Collapse isOpen={showWeight[cat]}>
      <div class="dupo-menu-pane mb-2">
        <ItemResponse
          type="number"
          min={0}
          title={cost_description[cat]?.weight?.name + " weight"}
          value={$lossWeight[cat].weight}
          toke={cat}
          {inputFocusAction}
          {inputBlurAction}
          changeAction={(event) => {
            updateLossCost(cat, event);
            $systemLog.log({
              message: `Update loss weight for ${cat}`,
              category: "recommender",
              loss_key: `${cat}`,
              from: $lossWeight[cat].weight,
              to: parseFloat(event.target.value),
            });
          }}
        />
        {#if cost_description[cat]?.weight?.desc}
          <div class="dupo-menu-pane-row pt-1">
            <p class="text-sm">{cost_description[cat]?.weight?.desc}</p>
          </div>
        {/if}
      </div>
      {#if $lossWeight[cat].by_channel}
        {#each Object.keys($lossWeight[cat].by_channel) as cat2}
          <div class="dupo-menu-pane mb-2">
            <ItemResponse
              type="number"
              min={0}
              title={cost_description[cat].by_channel[cat2].name}
              value={$lossWeight[cat].by_channel[cat2]}
              toke={cat + "-" + cat2}
              {inputFocusAction}
              {inputBlurAction}
              changeAction={(event) => {
                updateLossCost(cat + "." + cat2, event);
                $systemLog.log({
                  message: `Update loss weight for ${cat}.${cat2}`,
                  category: "recommender",
                  loss_key: `${cat}.${cat2}`,
                  from: $lossWeight[cat].weight,
                  to: parseFloat(event.target.value),
                });
              }}
            />
            {#if cost_description[cat].by_channel[cat2].desc}
              <div class="dupo-menu-pane-row pt-1">
                <p class="text-sm">
                  {cost_description[cat].by_channel[cat2].desc}
                </p>
              </div>
            {/if}
          </div>
        {/each}
      {/if}
      <div class="pane-divider" />
    </Collapse>
  {/each}
  <div class="pane-divider" />
  <div class="dupo-menu-pane mb-2">
    <div class="dupo-menu-pane-button-row">
      <button
        type="button"
        on:click={() => {
          cancelSubMenu();
          $systemLog.log({
            message: `Close editing recommendation parameters`,
          });
        }}><i class="bi bi-arrow-left me-1" />Go back</button
      >
    </div>
  </div>
{:else if subMenu == "design_direction"}
  <div class="dupo-menu-pane mb-2 pt-3">
    <div class="dupo-menu-pane-row">
      <Label for="design_direction">Design direction for exploration</Label>
      <p class="text-sm">
        It helps the design alternative recommender work better!
      </p>
    </div>
  </div>
  <div class="dupo-menu-pane mb-2">
    <div class="dupo-menu-pane-form-row">
      <Input
        id="design_direction"
        name="design_direction"
        type="select"
        class="custom-form-select"
        on:focus={inputFocusAction}
        on:blur={inputBlurAction}
        value={$responsiveDir}
        on:change={(event) => {
          responsiveDir.set(event.target.value);
          $systemLog.log({
            message: "Change responsive design direction",
            value: event.target.value,
          });
        }}
      >
        <option value={undefined} />
        {#each ResponsiveDirections as opt}
          <option value={opt}>{opt}</option>
        {/each}
      </Input>
    </div>
  </div>
  <div class="pane-divider" />
  <div class="dupo-menu-pane mb-2">
    <div class="dupo-menu-pane-button-row">
      <button
        type="button"
        on:click={() => {
          cancelSubMenu();
          $systemLog.log({
            message: `Close editing design direction`,
          });
        }}><i class="bi bi-arrow-left me-1" />Go back</button
      >
    </div>
  </div>
{/if}

<style>
  .danger {
    background-color: rgba(254, 5, 5, 0.15);
    color: rgba(254, 5, 5, 1);
  }
  .danger:hover {
    background-color: rgba(254, 5, 5, 0.25);
  }
  i.checked {
    color: #0d6efd;
  }
  .value-preview {
    padding: 0.05rem 0.4rem;
    font-size: 0.8rem;
    background-color: white;
    border: 1px solid #ddd;
    border-radius: var(--default-radius);
  }
</style>
